module.exports = __webpack_public_path__ + "static/media/averta-light.7fc07c60.woff";